import produce from 'immer';

const INITIAL_STATE = {
    loading: false,
    data: [],
    page: 1,
    pageSize: 9999,
    totalCount: 0,
    totalPages: 0,
    find: null,
    params: {},
};

export default function postoPlanejamentoGpp(state = INITIAL_STATE, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            case '@postoplanejamentogpp/GPP_IN_REQUEST': {
                draft.loading = true;
                break;
            }

            case '@postoplanejamentogpp/FAILED_REQUEST': {
                draft.loading = false;
                break;
            }

            case '@postoplanejamentogpp/SUCCESS_IN_REQUEST': {
                draft.loading = false;
                draft.data = action.payload.gpp;
                draft.page = action.payload.page;
                draft.pageSize = action.payload.pageSize;
                draft.totalCount = action.payload.totalCount;
                draft.totalPages = action.payload.totalPages;
                draft.find = {};
                break;
            }

            case '@postoplanejamentogpp/SUCCESS_REQUEST': {
                draft.loading = false;
                draft.find = action.payload.gpp;
                break;
            }

            case '@postoplanejamentogpp/RECORD_FILTERING': {
                draft.loading = true;
                //draft.params = { ...draft.params, ...action.payload.params };
                draft.params = action.payload.params;
                break;
            }

            case '@hooks/RESET': {
                draft.data = [];
                draft.page = 1;
                draft.pageSize = 10;
                draft.totalCount = 0;
                draft.totalPages = 0;
                draft.find = null;
                draft.params = {};
                break;
            }

            default:
        }
    });
}
